import { render, staticRenderFns, recyclableRender, components } from "./pay-h5.vue?vue&type=template&id=de888476&"
var renderjs
import script from "./pay-h5.vue?vue&type=script&lang=js&"
export * from "./pay-h5.vue?vue&type=script&lang=js&"
import style0 from "./pay-h5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order/pay-h5/pay-h5.vue"
export default component.exports